import FormExample from '../components/FormExample';
import { AboutUsChart } from '../components/AboutUsChart';
import AboutUsImageGrid from '../components/AboutUsImageGrid';
import { HeroImage } from '../components/HeroImage';
import { createFileRoute } from '@tanstack/react-router';
import Footer from '../components/Footer';
import { usePageMeta } from '../hooks/usePageMeta';

export const Route = createFileRoute('/about')({
  component: AboutComponent,
});

function AboutComponent() {
  usePageMeta(
    'About Us | Boyden Renovations',
    'Meet the Boyden Renovations team — experienced craftsmen dedicated to transforming your home with quality and care.'
  );

  return (
    <div data-nav-theme="light">
      <HeroImage
        imageUrl="https://res.cloudinary.com/dtgkdtn4o/image/upload/v1777655933/Website/Gregory_Primary_Bathroom/LGphoto-20.webp"
        title="Meet The Team"
        overlayOpacity={0.2}
      />
      <AboutUsChart />
      <AboutUsImageGrid
        data-nav-theme="light"
        images={[
          '/br-1.webp',
          '/br-2.webp',
          '/br-3.webp',
          '/br-4.webp',
          '/br-5.webp',
        ]}
        imageInfo={[
          { name: 'Dominic Boyden', title: 'Managing Partner' },
          { name: 'Damien Boyden', title: 'Managing Partner' },
          { name: 'John Boyden', title: 'Managing Partner' },
          { name: 'Jon Markwood', title: 'Managing Partner' },
          {
            name: 'Annie Morris',
            title: 'Client Services Coordinator & Design Consultant',
          },
        ]}
      />
      <FormExample isLoaded />
      <Footer isLoaded />
    </div>
  );
}
